import { useMutation, useQueryClient } from "@tanstack/react-query";
import { markVerificationStagesAsPrinted } from "../requests/mark-as-printed.ts";
import { verifyKeys } from "../queries/keys.ts";
import type { MarkVerificationStagesAsPrintedRequest } from "../../types.ts";

// Mutation hook for marking verification stages as printed
export const useMarkAsPrintedMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: MarkVerificationStagesAsPrintedRequest) => {
      const response = await markVerificationStagesAsPrinted(
        data,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [...verifyKeys.all, "stagesToVerify"],
      });
    },
  });
};
